import type {FeatureProps, GrantedSpell, Resource} from './types';

export function propsAtLevel(props: FeatureProps | null | undefined, level: number): FeatureProps | undefined {
	if (!props) return undefined;
	const {levels, ...baseProps} = props;
	if (!levels) return baseProps;

	return Object.keys(levels)
		.map(Number)
		.filter((propsLevel) => propsLevel <= level)
		.sort((first, second) => first - second)
		.reduce<FeatureProps>((merged, propsLevel) => mergeProps(merged, levels[propsLevel]), baseProps);
}

export function mergeResources(base: Resource[], additions: Resource[]): Resource[] {
	const merged = [...base];
	for (const resource of additions) {
		const index = merged.findIndex((existing) => existing.id === resource.id);
		if (index === -1) merged.push(resource);
		else merged[index] = {...merged[index], ...resource};
	}
	return merged;
}

function mergeProps(base: FeatureProps, addition: FeatureProps): FeatureProps {
	const merged: FeatureProps = {...base};
	for (const [name, value] of Object.entries(addition)) {
		const baseValue = merged[name];
		if (name === 'resources') merged.resources = mergeResources(base.resources || [], value as Resource[]);
		else if (name === 'spells') merged.spells = [...(base.spells || []), ...(value as GrantedSpell[])];
		else if (isPlainObject(baseValue) && isPlainObject(value)) merged[name] = {...baseValue, ...value};
		else merged[name] = value;
	}
	return merged;
}

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
	!!value && typeof value === 'object' && !Array.isArray(value);
